import { MoreVertIcon } from '@/assets/icons'
import { iconSizes } from '@/theme/tokens'
import React from 'react'
import ActionMenu from '../ActionMenu'

export interface EventMenuProps {
	eventName: string
	onEdit: () => void
	onMove: () => void
	onDelete: () => void
}

/** The "⋮" on an event card: the three things you do to an event from the list — edit it, move it to another day, delete it. */
const EventMenu: React.FC<EventMenuProps> = ({ eventName, onEdit, onMove, onDelete }) => (
	<ActionMenu
		label={`Actions for ${eventName}`}
		icon={<MoreVertIcon sx={{ fontSize: iconSizes.md }} />}
		items={[
			{ label: 'Edit', onSelect: onEdit },
			{ label: 'Move to day…', onSelect: onMove },
			{ label: 'Delete', onSelect: onDelete, danger: true },
		]}
	/>
)

export default EventMenu
